<template>
  <div class="manualStyle">
    <top-component></top-component>
    <div class="manualContainer">
        <div class="manual_tit"><p>9.14-9.16线上活动日程表</p></div>

        <div class="manal_text">
            <el-table  :span-method="objectSpanMethod"
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    prop="date"
                    label="日期">
                </el-table-column>
                <el-table-column
                    prop="time"
                    label="时间">
                </el-table-column>
                <el-table-column
                    prop="report"
                    label="报告主题">
                </el-table-column>
               
            </el-table>




        </div>
        
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  export default {
    name: 'manual',
    data() {
      return {
          tableData: [{
            date: '9月14日',
            time: '8:30-9:00',
            report: '祝福视频',
          },
          {
            date: '9月14日',
            time: '9:00—9:30',
            report: '开幕式',
          },
          {
            date: '9月14日',
            time: '9:30—10:30',
            report: '阅读力决定学习力',
          },
          {
            date: '9月14日',
            time: '10:40—11:10',
            report: ' 一带一路文化教育大系视频-外研社',
          },
          {
            date: '9月14日',
            time: '11:20—11:40',
            report: '宣传片：国防工业出版社',
          },
          {
            date: '9月14日',
            time: '13:30—14:00',
            report: '祝福视频',
          },
          {
            date: '9月14日',
            time: '14:00—16:10',
            report: '三新文化第十七届馆藏与出版论坛：时代变革中的馆藏发展',
          },
          {
            date: '9月14日',
            time: '16:20-16:40',
            report: '国防工业出版社宣传片',
          },

          {
            date: '9月15日',
            time: '8:30—9：00',
            report: '祝福视频',
          },
          {
            date: '9月15日',
            time: '9:30—10:30',
            report: '学海无涯“书”作舟——从中华经典中汲取人生幸福之道',
          },
          {
            date: '9月15日',
            time: '10:40-11:00',
            report: '新书推荐：上海大学出版社',
          },
          {
            date: '9月15日',
            time: '11:20—11:40',
            report: '宣传片：国防工业出版社',
          },

          {
            date: '9月15日',
            time: '13:30—14:00',
            report: '祝福视频',
          },
          {
            date: '9月15日',
            time: '14:00—15:00',
            report: '修身为本书香高门第，天下为公智慧伴一生',
          },
          {
            date: '9月15日',
            time: '15:40-16:00',
            report: '宣传片：国防工业出版社',
          },


          {
            date: '9月16日',
            time: '8:30—9：00',
            report: '祝福视频',
          },
          {
            date: '9月16日',
            time: '9:30—10:30',
            report: '阅读力决定学习力',
          },
          {
            date: '9月16日',
            time: '10:30—11:30',
            report: '学海无涯“书”作舟——从中华经典中汲取人生幸福之道',
          },

          {
            date: '9月16日',
            time: '13:00—13:30',
            report: '祝福视频',
          },
          {
            date: '9月16日',
            time: '13:30—16:00',
            report: '三新文化第十七届馆藏与出版论坛：时代变革中的馆藏发展',
          },

          {
            date: '9月16日',
            time: '16:00-17:00',
            report: '修身为本书香高门第，天下为公智慧伴一生',
          },
          {
            date: '9月16日',
            time: '17:00-17:30',
            report: '闭幕式',
          },
          ]
      }
    },
    mounted() {
    },
    methods: {
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex  === 0) {
                    return {
                        rowspan: 8,
                        colspan: 1
                    };
                } 
                else if (rowIndex  === 8) {
                    return {
                        rowspan: 7,
                        colspan: 1
                    };
                } 
                else if(rowIndex === 15) {
                    return {
                        rowspan: 7,
                        colspan: 1
                    };
                }else{
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        }
      
    },
    components: {
      BottomComponent,
      TopComponent,
    },
  }
</script>

<style scoped lang="scss">
  .manualStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;

    .manualContainer{
        background-color: #fff;
        width: 1180px;
        margin: 30px auto 30px;
        .manual_tit{
            text-align: center;
            line-height: 60px;
            font-weight: 500;
            font-size: 24px;
        }

    }
  }





</style>



// WEBPACK FOOTER //
// src/views/manual/manual.vue